'use client';

import { Swiper, SwiperSlide } from 'swiper/react';

import { SERVICE_SLIDES } from '../constants';

import { TranslatedComponent } from '@/shared/types';

/** Блок с функционалом сервиса */
export const ServiceSection = ({ translations }: TranslatedComponent) => {
  const orderedSlides = SERVICE_SLIDES.sort((a, b) => a.order - b.order);

  return (
    <section className="m-auto max-w-[1208px] pt-16 md:pt-30">
      <div className="w-full max-w-[760px] px-4">
        <h3 className="min-dm:tracking-[-0,44px] pb-9 text-[30px] leading-[52px] font-medium tracking-[-0.3px] max-sm:pb-3 max-sm:leading-[38px] md:pb-5 md:text-[44px]">
          {translations.sectionServiceTasksTitle}
        </h3>

        <p className="pb-12 text-[16px] leading-[24px] font-normal max-sm:pb-9">
          {translations.staticApiServiceSectionTitleDescription}
        </p>
      </div>
      <div>
        {/** Блок для мобильных */}
        <div className="md:hidden">
          <Swiper
            spaceBetween={16}
            slidesPerView="auto"
            className="ml-[-8px]! pr-14! pl-6!"
          >
            {orderedSlides.map((slide) => {
              return (
                <SwiperSlide key={slide.order}>
                  <div className="bg-surface-base-secondary relative flex size-full h-[214px] flex-col items-start justify-between overflow-hidden rounded-[16px] p-4 pb-3">
                    <div className="bg-surface-base-blur inline-flex rounded-[8px] p-1">
                      {slide.icon}
                    </div>
                    <p className="flex flex-col gap-2">
                      <span className="text-[20px] leading-[24px] font-medium tracking-[-0.1px]">
                        {translations[slide.titleKey]}
                      </span>
                      <span className="text-text-base-secondary text-[16px] leading-[24px] font-normal tracking-[-0.16px]">
                        {translations[slide.descriptionKey]}
                      </span>
                    </p>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        {/** Блок для ПК */}
        <div className="grid grid-cols-4 gap-4 max-md:hidden md:px-4">
          {orderedSlides.map((slide) => {
            return (
              <div
                key={slide.order}
                className="bg-surface-base-secondary relative flex size-full h-[248px] flex-col items-start justify-between overflow-hidden rounded-[20px] p-6"
              >
                <p className="flex flex-col gap-2">
                  <span className="text-[18px] leading-[28px] font-medium tracking-[-0.18px]">
                    {translations[slide.titleKey]}
                  </span>
                  <span className="text-text-base-secondary text-[16px] leading-[24px] font-normal tracking-[-0.16px]">
                    {translations[slide.descriptionKey]}
                  </span>
                </p>
                <div className="bg-surface-base-blur inline-flex rounded-[8px] p-1">
                  {slide.icon}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
